/**
 * 양식 업로드 모달의 엑셀 시트 선택 후보 산정 — sheet-names API가 돌려준 시트 이름 목록에서
 * 선택 UI를 띄울지 정한다. 시트가 2개 이상일 때만 목록을 반환하고(1개면 서버 자동 선택과
 * 결과가 같아 숨김 — 현행 유지) 그 미만이면 null.
 *
 * 종전에는 "내용(행)이 있는 시트"만 추렸지만, 경량 판독(bookSheets)은 시트 본문을 만들지 않아
 * `!ref`가 없고 내용 유무를 알 수 없다. 그래서 기준을 **전체 시트 수**로 바꾸고 표지·빈 시트도
 * 그대로 노출한다 — 격자 파싱 상한에 걸려 시트 목록이 통째로 사라지던 것(실측 47시트 파일)보다
 * 표지가 한 줄 섞이는 편이 낫다는 거래다. 기본값은 여전히 "자동(내용이 있는 첫 시트)"이라
 * 아무것도 고르지 않으면 서버 자동 선택으로 현행과 동일하게 동작한다.
 */
export function formImportSheetChoices(sheetNames: string[]): string[] | null {
  return sheetNames.length >= 2 ? sheetNames : null;
}
